<div class="container-pagina-espacios">
  <div class="descripcion-pagina">
    <b>Listado residentes:</b> Selecciona la fila de cada residente para ampliar su información y su grupo familiar.
  </div>
  <div class="contenido-tablas">
    <app-tabla-general [displayedColumns]="displayedColumns" [moduloActual]="'lugares'"></app-tabla-general>
    <app-listar-espacios></app-listar-espacios>
    <router-outlet></router-outlet>
  </div>
</div>
